import React from 'react'

import { Form, Col } from '_zari/core'

const MultiAlmacenFormGroup = ({ text, value, handleChange }) => {
  return (
    <Form.Group>
      {/* <Form.Label text={text} htmlFor={text} md={4} /> */}
      <Col md={12}>
        <Form.Checkbox
          id={`checkbox-${text}`}
          name={`check-box${text}`}
          label={text}
          value={value}
          checked={value}
          onChange={handleChange}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MultiAlmacenFormGroup)
